module.exports = __webpack_public_path__ + "static/img/fj3.54952459.png";